import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import { validateLocalPhoneNumber } from "../Utils/FormUtil";
import Recaptcha from "./GoogleRecaptcha";
import * as Icon from "./Icon";
import * as Widget from "./Widget2";

class JoinUsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeName: "",
      location: "",
      name: "",
      phone: "",
      FBlink: "",
      physicalStore: false,
      pourOverCoffee: false,
      cofferBeanBaking: false,
      showSuccess: false,
      showSpinner: false,
      hint: "",
      recaptcha: "",
      recaptchaKey: 0
    };
  }

  render() {
    let { onClose, open } = this.props;
    let {
      storeName,
      location,
      name,
      phone,
      FBlink,
      physicalStore,
      pourOverCoffee,
      cofferBeanBaking,
      showSuccess,
      showSpinner,
      hint,
      recaptchaKey
    } = this.state;

    return (
      <Dialog open={open} className={`${open ? "active" : ""}`}>
        <div className="backdrop" onClick={onClose} />
        {open && (
          <div className="container" onClick={e => e.stopPropagation()}>
            <div className="close" onClick={onClose}>
              <Icon.Close color="#575757" size={26} />
            </div>

            {showSuccess ? (
              <div className="content">
                <div
                  style={{
                    width: "100%",
                    height: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  <div className="title">
                    謝謝您的填寫，請耐心等候，我們將盡快與您聯繫！
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="content">
                  <div className="title">
                    {
                      "非常感謝你對好咖嚴選的支持，\n請協助填寫以下表單以便我們後續聯繫喔！"
                    }
                  </div>
                  <FormField css="margin-bottom: 20px;">
                    <div className="label">店家名稱(必填)</div>
                    <input
                      value={storeName}
                      onChange={e =>
                        this.setState({ storeName: e.target.value, hint: "" })
                      }
                    />
                  </FormField>
                  <FormField css="margin-bottom: 20px;">
                    <div className="label">所在地區(必填)</div>
                    <input
                      value={location}
                      onChange={e =>
                        this.setState({ location: e.target.value, hint: "" })
                      }
                    />
                  </FormField>
                  <FormField css="margin-bottom: 20px;">
                    <div className="label">聯絡人(必填)</div>
                    <input
                      value={name}
                      onChange={e =>
                        this.setState({ name: e.target.value, hint: "" })
                      }
                    />
                  </FormField>
                  <FormField css="margin-bottom: 20px;">
                    <div className="label">聯絡電話(必填)</div>
                    <input
                      value={phone}
                      onChange={e =>
                        this.setState({ phone: e.target.value, hint: "" })
                      }
                    />
                  </FormField>
                  <FormField css="margin-bottom: 20px;">
                    <div className="label">ＦＢ連結</div>
                    <input
                      value={FBlink}
                      onChange={e => this.setState({ FBlink: e.target.value })}
                    />
                  </FormField>
                  <FormField css="margin-bottom: 10px;">
                    <div className="label">勾選是否有以下條件(可複選)</div>
                    <div className="selector">
                      <Widget.Row
                        align="center"
                        extraCss="margin-bottom: 10px; cursor: pointer;"
                        onClick={() =>
                          this.setState({ physicalStore: !physicalStore })
                        }
                      >
                        {physicalStore ? (
                          <Icon.RadioButtonChecked size={20} color="#575757" />
                        ) : (
                          <Icon.RadioButtonUnchecked
                            size={20}
                            color="#575757"
                          />
                        )}
                        <div className="text">實體店家</div>
                      </Widget.Row>

                      <Widget.Row
                        align="center"
                        extraCss="margin-bottom: 10px; cursor: pointer;"
                        onClick={() =>
                          this.setState({ pourOverCoffee: !pourOverCoffee })
                        }
                      >
                        {pourOverCoffee ? (
                          <Icon.RadioButtonChecked size={20} color="#575757" />
                        ) : (
                          <Icon.RadioButtonUnchecked
                            size={20}
                            color="#575757"
                          />
                        )}
                        <div className="text">自家咖啡豆烘焙</div>
                      </Widget.Row>

                      <Widget.Row
                        align="center"
                        extraCss="margin-bottom: 10px; cursor: pointer;"
                        onClick={() =>
                          this.setState({ cofferBeanBaking: !cofferBeanBaking })
                        }
                      >
                        {cofferBeanBaking ? (
                          <Icon.RadioButtonChecked size={20} color="#575757" />
                        ) : (
                          <Icon.RadioButtonUnchecked
                            size={20}
                            color="#575757"
                          />
                        )}
                        <div className="text">店內提供手沖單品</div>
                      </Widget.Row>
                    </div>
                  </FormField>
                  <Recaptcha
                    key={recaptchaKey}
                    onChange={value => this.setState({ recaptcha: value })}
                  />
                </div>

                <div className="button-bar">
                  {hint && <div className="hint">{hint}</div>}
                  {showSpinner ? (
                    <Widget.Spinner />
                  ) : (
                    <button onClick={() => this._submit()}>送出</button>
                  )}
                </div>
              </>
            )}
          </div>
        )}
      </Dialog>
    );
  }

  _submit = () => {
    let { appActions } = this.props;
    let {
      storeName,
      location,
      name,
      phone,
      FBlink,
      physicalStore,
      pourOverCoffee,
      cofferBeanBaking,
      recaptcha
    } = this.state;

    if (!storeName || !location || !name || !phone) {
      this.setState({ hint: "必填項目不可為空" });
      return;
    } else if (!validateLocalPhoneNumber) {
      this.setState({ hint: "電子信箱不符格式" });
      return;
    } else if (!recaptcha) {
      this.setState({ hint: "請確認驗證機器人" });
      return;
    }

    let data = {
      storeName,
      location,
      name,
      phone,
      FBlink,
      physicalStore,
      pourOverCoffee,
      cofferBeanBaking
    };

    this.setState({ showSpinner: true });
    return appActions
      .creatContactMsg(data)
      .then(() => this.setState({ showSpinner: false }))
      .then(() => this.setState({ showSuccess: true }))
      .catch(err => {
        console.warn(err);
        this.setState({ showSpinner: false });
      });
  };
}

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & .label {
    margin-bottom: 13px;
    font-size: 14px;
    color: #575757;
  }

  & > input {
    flex: 1;
    border: 1px solid #dadada;
    padding: 15px;
    font-size: 14px;
    height: 35px;
    color: #575757;

    :focus {
      outline: none;
    }
  }

  & > .selector {
    .text {
      margin-left: 10px;
      font-size: 14px;
      color: #575757;
    }
  }

  ${props => props.css};
`;

let Dialog = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  display: flex;

  transform: translateX(-100vw);
  transition: 0s ease-in transform 0.5s;

  &.active {
    transform: translateX(0);
    transition: 0s ease-in transform 0s;
  }

  & .backdrop {
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: ${props => (props.open ? 1 : 0)};
    transition: 0.2s ease-in opacity;
  }

  & .container {
    background-color: white;
    width: 100%;
    max-width: 594px;
    min-height: 200px;
    max-height: calc(100% - 60px);
    border-radius: 5px;
    z-index: 1001;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 70px 20px 40px 20px;

    & > .close {
      cursor: pointer;
      position: absolute;
      top: 20px;
      right: 20px;
    }

    & > .content {
      overflow: auto;
      max-width: 420px;
      width: 100%;

      & .title {
        margin-bottom: 20px;
        white-space: pre-wrap;
        line-height: 24px;
        font-size: 16px;
        color: #575757;
      }
    }

    & .button-bar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 30px;
      max-width: 420px;
      width: 100%;

      & > .hint {
        flex: 1;
        margin-right: 5px;
        font-size: 14px;
        color: red;
      }

      & > button {
        border: 1px solid #bd9f84;
        background: #ffffff;
        text-align: center;
        cursor: pointer;
        min-width: 116px;
        min-height: 40px;

        font-size: 16px;
        color: #bd9f84;

        :focus {
          outline: none;
        }
      }
    }

    @media screen and (max-width: 700px) {
      min-width: initial;
      padding: 40px 60px;
    }

    @media screen and (max-width: 550px) {
      padding: 25px;
    }
  }
`;

export default connect(
  null,
  ActionCreator
)(JoinUsDialog);
